import React from 'react';
import { useDecumulationDetailsQuery } from '../../../../../api/useDecumulationDetailsQuery';
import { GoalCard } from '../../../../../GoalsSummary/components/GoalCard/GoalCard';
import { GoalSummary } from '../../../../../GoalsSummary/useGoalsSummary';

interface Props {
  goal: GoalSummary;
}

export const DecumulationCard = ({ goal }: Props) => {
  const { isLoading, isError, refetch, data } = useDecumulationDetailsQuery();

  if (isLoading) {
    return <GoalCard isLoading goal={goal} />;
  }

  if (isError) {
    return <GoalCard isError onRetry={refetch} goal={goal} />;
  }

  if (!data) {
    throw new Error('No data for the decumulation card');
  }

  const goalWithResults: GoalSummary = {
    ...data,
    GoalResults: Object.entries(data.GoalResults).map(([key, value]) => ({
      label: key,
      value,
    })),
  };

  return <GoalCard goal={goalWithResults} />;
};
